"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFacilityChangeRedirect = useFacilityChangeRedirect;
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var facility_scoped_query_1 = require("../utils/facility-scoped-query");
/** Sends a detail page back to its list when the header facility changes, since the open record belongs to the old facility. */
function useFacilityChangeRedirect(route) {
    var navigate = (0, react_router_dom_1.useNavigate)();
    var facilityId = (0, facility_scoped_query_1.useActiveFacilityId)();
    // The first facility seen is the one the page opened under, including one the selector fills in after load.
    var openedFacilityIdRef = (0, react_1.useRef)(facilityId);
    (0, react_1.useEffect)(function () {
        if (!openedFacilityIdRef.current) {
            openedFacilityIdRef.current = facilityId;
            return;
        }
        if (facilityId && facilityId !== openedFacilityIdRef.current) {
            navigate(route, { replace: true });
        }
    }, [facilityId, route, navigate]);
}
